module.exports = __webpack_public_path__ + "img/pocket_bag_length.9052b9ef.png";